<template>
  <!-- ▼一括更新モーダル -->
  <div
    id="interview-place-register-modal"
    class="reveal boss-modal-container pega-modal-position"
    data-reveal
  >
    <h1
      class="boss-page-title boss-page-title-layout-title pega-mb-25"
      data-test="modal-title"
    >
      面接場所を{{ titleLabel }}
    </h1>
    <div class="boss-layout boss-layout-center">
      <div class="pega-bulk-update-container">
        <div class="boss-color-red">
          webや電話による面接の場合、こちらではなく、<br>
          メッセージ本文にURLを記載してください。
        </div>
        <div>
          <div data-test="modal-body-display-address">
            表示用住所(100文字以内)
          </div>
          <div>
            <input
              v-model="displayAddress"
              class="boss-input boss-input-fill"
              type="text"
              placeholder="例：サンプル港区赤坂本店（※URLは入力できません）"
              data-test="display-address"
            >
          </div>
        </div>
        <div data-test="modal-body-display-google-map-address">
          Googleマップ用住所(100文字以内)
        </div>
        <div>
          <input
            v-model="googleMapAddress"
            class="boss-input boss-input-fill"
            type="text"
            placeholder="例：東京都港区赤坂3-21-20ロングビーチビル（※URLは入力できません）"
            data-test="display-google-map-address"
          >
        </div>
        <button
          :disabled="!googleMapAddress"
          class="boss-button-center pega-button"
          type="button"
          data-test="preview-button"
          @click="previewOpen()"
        >
          プレビュー
        </button>
        <div>
          <button
            :disabled="!displayAddress"
            class="float-center boss-button-center boss-button-large pega-button pega-mr-20 pega-mt-15"
            type="button"
            data-test="register-button"
            @click="registerOrUpdate()"
          >
            {{ actionLabel }}
          </button>
          <button
            class="float-center boss-button-center boss-button-large pega-mt-15"
            type="button"
            data-close
            aria-label="Close modal"
            data-test="cancel-button"
            @click="closeReveal()"
          >
            キャンセル
          </button>
        </div>
        <div
          v-if="!isInterviewInformation"
          data-test="modal-body-display-interview-link"
        >
          登録した面接場所の編集・削除は<a
            data-test="interview"
            @click="goToInterviewInformation"
          >こちら</a>
        </div>
      </div>
    </div>
    <button
      class="close-button boss-close-button boss-icon-cross"
      data-close
      aria-label="Close modal"
      type="button"
      @click="closeReveal()"
    />
  </div>
  <!-- ▲一括更新モーダル -->
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import Indicator from '@/lib/indicator'
import { mapActions } from 'vuex'

export default {
  props: {
    interviewPlace: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      placeId: null,
      displayAddress: '',
      googleMapAddress: ''
    }
  },
  computed: {
    requestParameter () {
      return {
        displayAddress: this.displayAddress,
        googleMapAddress: this.googleMapAddress
      }
    },
    isInterviewInformation () {
      return (this.$route.name === 'interviewInformationTop')
    },
    isEdit () {
      return (typeof this.interviewPlace !== 'undefined') && (Object.keys(this.interviewPlace).length > 0)
    },
    titleLabel () {
      return this.isEdit ? '編集' : '追加'
    },
    actionLabel () {
      return this.isEdit ? '更新する' : '登録する'
    }
  },
  watch: {
    interviewPlace: {
      handler () {
        this.$set(this, 'placeId', this.interviewPlace.placeId)
        this.$set(this, 'displayAddress', this.interviewPlace.placeName)
        this.$set(this, 'googleMapAddress', this.interviewPlace.googleMapAddress)
      }
    }
  },
  methods: {
    ...mapActions('settings', [
      'storeInterviewPlaces'
    ]),
    doAction () {
      this.modal = new Foundation.Reveal(jQuery('#interview-place-register-modal'), { closeOnClick: false })
      this.modal.open()
    },
    goToInterviewInformation () {
      this.closeReveal()
      this.$router.push({ name: 'interviewInformationTop' })
    },
    closeReveal () {
      this.resetInterviewPlace()
      this.modal.close()
    },
    emitFetchPlaces () {
      if (this.isInterviewInformation) {
        this.$emit('fetchPlaces') // 面接情報の再取得
      }
    },
    registerOrUpdate () {
      this.isEdit ? this.update(this.placeId) : this.register()
    },
    register () {
      Indicator.emitShow()
      this.$http.secured.post('/company/settings/entry/interview_place', this.requestParameter).then(() => {
        this.$toasted.global.success({ message: '面接場所を登録しました。' })
        this.storeInterviewPlaces()
        this.emitFetchPlaces()
      }).finally(() => {
        Indicator.emitHide()
        this.closeReveal()
      })
    },
    update (id) {
      Indicator.emitShow()
      this.$http.secured.put(`/company/settings/entry/interview_place/${id}`, this.requestParameter).then(() => {
        this.$toasted.global.success({ message: '面接場所を更新しました。' })
        this.storeInterviewPlaces()
        this.emitFetchPlaces()
      }).finally(() => {
        Indicator.emitHide()
        this.closeReveal()
      })
    },
    resetInterviewPlace () {
      this.$emit('resetInterviewPlace')
    },
    previewOpen () {
      const openWidth = 900
      const openHeight = 550

      const screenX = window.screenX
      const screenY = window.screenY
      const centerX = window.outerWidth / 2
      const centerY = window.outerHeight / 2
      const displayX = screenX + centerX - (openWidth / 2)
      const displayY = screenY + centerY - (openHeight / 2)
      const url = `https://www.google.co.jp/maps?q=${this.googleMapAddress}`

      window.open(encodeURI(url), '_blank', `width=${openWidth}px, height=${openHeight}px,left=${displayX}px,top=${displayY}px,toolbar=yes, scrollbars=yes, menubar=yes, resizable=yes`)
    }
  }
}
</script>
